import { useStaticQuery, graphql } from 'gatsby'

export const useServiceAreasQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query ServiceAreasQuery {
      wpPage(title: { eq: "Home" }) {
        serviceAreas {
          serviceAreas {
            backgroundImageMobile {
              sourceUrl
                mediaDetails {
                  width
                  height
                }
            }
            backgroundImageDesktop {
              sourceUrl
                mediaDetails {
                  width
                  height
                }
            }
            containerBackgroundImage {
              sourceUrl
                mediaDetails {
                  width
                  height
                }
            }
            containerBackgroundMobile {
              sourceUrl
                mediaDetails {
                  width
                  height
                }
            }
            image {
              sourceUrl
                mediaDetails {
                  width
                  height
                }
            }
            imageAltText
            title
            subtitle
            text
            locationIcon {
              localFile {
                publicURL
              }
            }
            states{
              state
              countiesAndTowns {
                county
                towns
              }
            }
            buttonText
          }
        }
      }
    }
  `)
  return wpPage.serviceAreas.serviceAreas
}
